import { notification } from 'antd';
import { appApi } from 'services/api/api-instance';
import type { ListResponseWithPagination } from 'services/api/types';
import type { CreateRegionBody, Region, RegionsListRequest, UpdateRegionBody } from './types';

export const getRegionsList = (
  params: RegionsListRequest = {},
): Promise<ListResponseWithPagination<Region>> => {
  return appApi
    .get('/regions', {
      params,
      paramsSerializer: { indexes: null }, // Для правильной сериализации массивов sort
    })
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Не удалось загрузить регионы' });
      throw error;
    });
};

export const getRegions = (): Promise<ListResponseWithPagination<Region>> => {
  return appApi
    .get('/regions', { params: { size: 2000 } })
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Не удалось загрузить регионы' });
      throw error;
    });
};

export const createRegion = (body: CreateRegionBody): Promise<Region> => {
  return appApi
    .post('/regions', body)
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Не удалось создать регион' });
      throw error;
    });
};

export const removeRegion = (regionId: number): Promise<void> => {
  return appApi
    .delete(`/regions/${regionId}`)
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Не удалось удалить регион' });
      throw error;
    });
};

export const updateRegion = (regionId: number, body: UpdateRegionBody): Promise<Region> => {
  return appApi
    .put(`/regions/${regionId}`, body)
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Не удалось обновить регион' });
      throw error;
    });
};
